import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-video-uploader',
  templateUrl: './video-uploader.component.html',
  styleUrls: ['./video-uploader.component.css']
})
export class VideoUploaderComponent implements OnInit {

  @Input() src;
  fileToUpload: File = null;
  @Output() input:EventEmitter<string>=new EventEmitter();
  constructor() { }

  ngOnInit() {

  }
  
  showPopover(e) {

  }

  handleBaseFileInput(files: FileList) {
    this.fileToUpload = <File>files.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.input.emit(event.target.result);
      var url = (<FileReader>event.target).result;
      console.log(url)
    }
    reader.readAsDataURL(this.fileToUpload);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/video-uploader/video-uploader.component.ts